import React, { useEffect, useContext, useState, useRef } from 'react';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useTour } from '@reactour/tour';
import classNames from 'classnames';
import { useMeasure } from 'react-use';
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Carousel from '../../../components/bootstrap/Carousel';
import CarouselSlide from '../../../components/bootstrap/CarouselSlide';
import Pic from '../../../assets/img/wanna/richie/richie.png';
import Pic2 from '../../../assets/img/wanna/richie/richie2.png';
import Pic3 from '../../../assets/img/wanna/richie/richie3.png';
import Pic4 from '../../../assets/img/wanna/richie/richie4.png';
import Pic5 from '../../../assets/img/wanna/richie/richie5.png';
import Pic6 from '../../../assets/img/wanna/richie/richie6.png';
import Pic7 from '../../../assets/img/wanna/richie/richie7.png';
import Pic8 from '../../../assets/img/wanna/richie/richie8.png';
import SubHeader, {
	SubHeaderLeft,
	SubHeaderRight,
	SubheaderSeparator,
} from '../../../layout/SubHeader/SubHeader';
import Button from '../../../components/bootstrap/Button';
import CommonGridProductItem from '../../common/CommonGridProductItemSwl';
import Card, { CardActions } from '../../../components/bootstrap/Card';
import { userAuth } from '../../../contexts/userContext';
import useDarkMode from '../../../hooks/useDarkMode';
import apiServicewt from '../../../api/apiServicewt';
import { motion, AnimatePresence } from 'framer-motion';
import { useMediaQuery } from '@mui/material';
import { layoutMenu } from '../../../menu';
import '../../presentation/auth/Home.css';
import apiService from '../../../api/apiService';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import LANG, { getLangWithKey } from '../../../lang';
import useSortableData from '../../../hooks/useSortableData';
import Select from '../../../components/bootstrap/forms/Select';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import CustomSearchInput from '../demo-pages/helper/CustomSearchInput';
import SelectOption from '../../../components/bootstrap/Option';
import { PER_COUNT } from '../../../components/PaginationButtonsdb';
import NoItems from '../../../components/NoItems';
import CommonProductView from '../../common/CommonProductView';
import Popovers from '../../../components/bootstrap/Popovers';
import { useLanguageSwitch } from '../../../contexts/LanguageSwitchContext';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import showNotification from '../../../components/extras/showNotification';
import Icon from '../../../components/icon/Icon';
import Logo from '../../../components/Logo';

const tabStyles = {
	container: {
		display: 'inline-flex',
		borderRadius: '999px',
		padding: '6px',
		background: 'rgba(0,0,0,0.03)',
	},
	tab: (active) => ({
		padding: '8px 18px',
		borderRadius: '999px',
		cursor: 'pointer',
		color: active ? '#ffffff' : '#222',
		background: active ? '#6c5dd3' : 'transparent',
		fontWeight: 600,
		margin: '2px',
		boxShadow: active ? '0 2px 6px rgba(108,93,211,0.25)' : 'none',
	}),
};

const Home = () => {
	// Ref to skip first intersection event
	const isFirstLoadRef = useRef(true);
	// Ref to hold observer instance for cleanup
	const observerRef = useRef(null);
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [ref, { height }] = useMeasure();
	const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'dark'];
	const [selectedImage, setSelectedImage] = useState(null);

	const [data, setData] = useState([]);
	const [scurrency, setScurrency] = useState([]);
	const [vslider, setVslider] = useState(null);
	const [products, setProducts] = useState([]);
	const [activeTab, setActiveTab] = useState('services');
	const [editItem, setEditItem] = useState(null);
	const [editPanel, setEditPanel] = useState(false);
	const [branches, setBranches] = useState([]);
	const [sitename, setSitename] = useState([]);
	const [branch, setbranch] = useState({ error: false, msg: t('*Required'), data: '' });
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	// Derived responsive flags
	const isMobile = windowWidth <= 576; // bootstrap-esque breakpoint
	const { token } = useContext(userAuth);

	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setPerPage] = useState(PER_COUNT['25']);
	const [totalRows, settotalRows] = useState(25);
	const [isLoadingMore, setIsLoadingMore] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const [isListLoading, setIsListLoading] = useState(false);
	const bottomRef = useRef(null);
	const [showScrollTop, setShowScrollTop] = useState(false);
	const requestIdRef = useRef(0);
	const controllerRef = useRef(null);
	const scrollAnimRef = useRef({ rafId: null, cancelHandler: null });
	// Prevent duplicate load triggers from IntersectionObserver
	const loadLockRef = useRef(false);
	const currentPageRef = useRef(1);
	// Refs mirroring state for stable IntersectionObserver callback
	const hasMoreRef = useRef(hasMore);
	const isLoadingMoreRef = useRef(isLoadingMore);
	const perPageRef = useRef(perPage);
	const isListLoadingRef = useRef(isListLoading);
	const hasLoadedFirstPageRef = useRef(false);
	const [totalRowsServices, setTotalRowsServices] = useState(null);
	const [totalRowsProducts, setTotalRowsProducts] = useState(null);
	const { items } = useSortableData(data);
	const [searchValue, setSearchValue] = useState('');
	const { isLangSwitchEnabled } = useLanguageSwitch();
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();

	const u_class = '.gt_container--hich1m';

	// Small, shared renderer for Theme + Language controls
	const ThemeLangControls = () => (
		<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
			<Popovers trigger='hover' desc='Dark / Light mode'>
				<Button
					{...styledBtn}
					icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
					onClick={() => setDarkModeStatus((prev) => !prev)}
					aria-label='Toggle theme'
					data-tour='dark-mode'
				/>
			</Popovers>
			{isLangSwitchEnabled && (
				<Dropdown>
					<DropdownToggle hasIcon={false}>
						<Button
							{...styledBtn}
							icon={getLangWithKey(i18n.language)?.icon}
							aria-label='Change language'
							data-tour='lang-selector'
						/>
					</DropdownToggle>
					<DropdownMenu isAlignmentEnd data-tour='lang-selector-menu'>
						{Object.keys(LANG).map((key) => (
							<DropdownItem key={LANG[key].lng}>
								<Button
									icon={LANG[key].icon}
									onClick={() => {
										if (controllerRef.current) controllerRef.current.abort();
										setActiveTab('products');
										setCurrentPage(1);
										setHasMore(true);
										setProducts([]);
										settotalRows(
											totalRowsProducts !== null ? totalRowsProducts : null,
										);
										fetchProductsWL(branch.data);
										changeLanguage(LANG[key].lng);
									}}>
									{LANG[key].text}
								</Button>
							</DropdownItem>
						))}
					</DropdownMenu>
				</Dropdown>
			)}
		</div>
	);

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		console.log('token', token);
		if (token?.session_key) {
			navigate('/services');
		}
	}, [token]);

	useEffect(() => {
		const storedTheme = localStorage.getItem('theme');
		if (storedTheme !== null) {
			setDarkModeStatus(storedTheme === 'dark');
		}
	}, [setDarkModeStatus]);

	useEffect(() => {
		localStorage.setItem('theme', darkModeStatus ? 'dark' : 'light');
		document.documentElement.setAttribute('theme', darkModeStatus ? 'dark' : 'light');
	}, [darkModeStatus]);

	const saveHomeCache = (selectedId) => {
		try {
			const cache = {
				branch: branch.data,
				activeTab,
				data,
				products,
				totalRowsServices,
				totalRowsProducts,
				perPage,
				currentPage,
				totalRows,
				selectedId: selectedId || null,
				fromDetail: true,
				savedAt: Date.now(),
			};
			sessionStorage.setItem('home-cache', JSON.stringify(cache));
		} catch (err) {}
	};

	const logbtn = windowWidth < 500 ? 'ab' : 'cd';

	const changeLanguage = (lang) => {
		document.querySelectorAll(u_class + ' .gt_switcher div.gt_selected').forEach(function (e) {
			e.addEventListener('click', function (evt) {
				evt.preventDefault();
				evt.stopPropagation();
				if (gt_slider_open) gt_hide_slider();
				else gt_show_slider(e.parentNode);
			});

			e.addEventListener('pointerenter', function (evt) {
				evt.target.parentNode
					.querySelectorAll('.gt_option img:not([src])')
					.forEach(function (img) {
						img.setAttribute('src', img.getAttribute('data-gt-lazy-src'));
					});
			});

			e.dispatchEvent(new PointerEvent('pointerenter', { bubbles: true, cancelable: true }));
		});

		const langLink = document.querySelector(`.gt_option a[data-gt-lang="${lang}"]`);

		if (langLink) {
			langLink.click();
			i18n.changeLanguage(lang);

			showNotification(
				<span className='d-flex align-items-center'>
					<Icon icon={getLangWithKey(lang)?.icon} size='lg' className='me-1' />
					<span>{`Language changed to ${getLangWithKey(lang)?.text}`}</span>
				</span>,
			);
		}
	};

	const styledBtn = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	// Keep refs in sync with state
	useEffect(() => {
		hasMoreRef.current = hasMore;
	}, [hasMore]);
	useEffect(() => {
		isLoadingMoreRef.current = isLoadingMore;
	}, [isLoadingMore]);
	useEffect(() => {
		perPageRef.current = perPage;
	}, [perPage]);
	useEffect(() => {
		isListLoadingRef.current = isListLoading;
	}, [isListLoading]);
	useEffect(() => {
		currentPageRef.current = currentPage;
	}, [currentPage]);

	useEffect(() => {
		const onScroll = () => {
			setShowScrollTop(window.scrollY > window.innerHeight);
		};
		window.addEventListener('scroll', onScroll);

		// Disconnect previous observer if exists
		if (observerRef.current) {
			observerRef.current.disconnect();
			observerRef.current = null;
		}

		// Only skip first intersection on mount/tab change
		isFirstLoadRef.current = true;

		if (bottomRef.current) {
			observerRef.current = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (!entry.isIntersecting) return;

						if (isFirstLoadRef.current) {
							isFirstLoadRef.current = false;
							return;
						}

						if (
							hasMoreRef.current &&
							!isLoadingMoreRef.current &&
							!loadLockRef.current &&
							hasLoadedFirstPageRef.current
						) {
							loadLockRef.current = true;
							const next = (currentPageRef.current || 1) + 1;
							currentPageRef.current = next;
							setCurrentPage(next);
							const p = handlefunction(next, perPageRef.current);
							if (p && typeof p.finally === 'function') {
								p.finally(() => {
									loadLockRef.current = false;
								});
							} else {
								loadLockRef.current = false;
							}
						}
					});
				},
				{ root: null, rootMargin: '200px', threshold: 0.1 },
			);
			observerRef.current.observe(bottomRef.current);
		}

		return () => {
			window.removeEventListener('scroll', onScroll);
			if (observerRef.current) {
				observerRef.current.disconnect();
				observerRef.current = null;
			}
		};
	}, [activeTab]);

	useEffect(() => {
		const fetchata = async () => {
			const item = { action: 'get_branches_list_wl' };

			const flechdata = await apiServicewt(item, navigate);
			setSitename(flechdata);
			if (Array.isArray(flechdata.data)) {
				const temp = flechdata.data.map((ele) => ({
					value: ele.branch_id,
					text: ele.branch_name,
				}));

				setBranches(temp);
				const defaultBranch = flechdata.data.find((branch) => branch.is_default);
				const selected =
					storedBranch || (defaultBranch ? defaultBranch.branch_id : temp[0].value);
				setbranch((pre) => ({ ...pre, data: selected }));

				setCurrentPage(1);
				setHasMore(true);
				if (controllerRef.current) controllerRef.current.abort();
				controllerRef.current = new AbortController();
				fetchServices(selected, 1, perPage, undefined, controllerRef.current.signal);
				fetchSlider(selected);

				localStorage.setItem('branches-list', JSON.stringify(temp));
				localStorage.setItem('selectedBranch', selected);

				let isReload = false;
				try {
					const navEntries = performance.getEntriesByType
						? performance.getEntriesByType('navigation')
						: null;
					if (navEntries && navEntries.length > 0) {
						isReload = navEntries[0].type === 'reload';
					} else if (performance && performance.navigation) {
						isReload = performance.navigation.type === 1;
					}
				} catch (e) {
					isReload = false;
				}
				let preserveCache = false;
				try {
					const cache = JSON.parse(sessionStorage.getItem('home-cache'));
					if (cache && cache.fromDetail && cache.savedAt) {
						const age = Date.now() - cache.savedAt;
						const TTL = 5 * 1000;
						if (age <= TTL) {
							preserveCache = true;
						}
					}
					if (isReload && !preserveCache) {
						sessionStorage.removeItem('home-cache');
						setActiveTab('services');
						setTotalRowsServices(null);
						setTotalRowsProducts(null);
						settotalRows(0);
						setData([]);
						setProducts([]);
					}
					if (cache && cache.branch === selected) {
						if (cache.activeTab) setActiveTab(cache.activeTab);
						if (cache.data) setData(cache.data);
						if (cache.products) setProducts(cache.products);
						if (typeof cache.totalRowsServices !== 'undefined')
							setTotalRowsServices(cache.totalRowsServices);
						if (typeof cache.totalRowsProducts !== 'undefined')
							setTotalRowsProducts(cache.totalRowsProducts);
						if (cache.perPage) setPerPage(cache.perPage);
						if (cache.currentPage) setCurrentPage(cache.currentPage);
						if (cache.totalRows) settotalRows(cache.totalRows);

						if (cache.selectedId) {
							setTimeout(() => {
								const el = document.getElementById(`home-item-${cache.selectedId}`);
								if (el && el.scrollIntoView) {
									el.scrollIntoView({ behavior: 'smooth', block: 'center' });
								}
							}, 100);
						}
					}
				} catch (err) {}
			} else {
				localStorage.removeItem('branches-list');
			}
		};

		const storedBranch = localStorage.getItem('selectedBranch');

		fetchata();
	}, []);

	const handleBranchChange = (e) => {
		sessionStorage.removeItem('home-cache');
		if (branch.error) {
			setbranch((pre) => ({ ...pre, error: false }));
		}

		setbranch((pre) => ({
			...pre,
			data: e.target.value,
		}));

		// Avoid immediate double-trigger from observer when list resets
		isFirstLoadRef.current = true;

		if (activeTab === 'services') {
			fetchServices(e.target.value);
			fetchSlider(e.target.value);
		} else {
			fetchProductsWL(e.target.value);
		}

		localStorage.setItem('selectedBranch', e.target.value);

		const branchesList = JSON.parse(localStorage.getItem('branches-list'));

		const selectedBranchName = branchesList?.find(
			(branch) => String(branch.value) === String(e.target.value),
		)?.text;

		window.dispatchEvent(
			new CustomEvent('branchChanged', {
				detail: { name: selectedBranchName },
			}),
		);
	};

	const { setIsOpen } = useTour();

	useEffect(() => {
		const timeout = setTimeout(() => setIsOpen(true), 3000);
		return () => {
			clearTimeout(timeout);
		};
	}, []);

	const fetchServices = async (
		branchId,
		page = 1,
		limit = perPage,
		searchVal = searchValue,
		signal = undefined,
	) => {
		const item = {
			action: 'services_list_wl',
			branch_id: branchId,
			page_id: page,
			limit: limit,
			search_value: searchVal,
		};
		try {
			if (page <= 1) {
				// Reset first-page loaded flag at the start of initial load
				hasLoadedFirstPageRef.current = false;
				setIsListLoading(true);
			}
			const flechdata = await apiServicewt(item, navigate, { signal });
			if (flechdata.data) {
				if (page > 1) {
					setData((prev) => [...prev, ...flechdata.data]);
				} else {
					setData(flechdata.data);
				}
				setScurrency(flechdata.currency);
			}

			if (flechdata.TotalRecords || flechdata.TotalRecords === 0) {
				setTotalRowsServices(flechdata.TotalRecords);
				if (activeTab === 'services') settotalRows(flechdata.TotalRecords);
				const currentCount =
					(page - 1) * limit + (flechdata.data ? flechdata.data.length : 0);

				if (flechdata.data && flechdata.data.length > 0) {
					setHasMore(
						currentCount < Number(flechdata.TotalRecords) &&
							flechdata.data.length === limit,
					);
				} else {
					setHasMore(false);
				}
			} else {
				setTotalRowsServices(0);
				if (activeTab === 'services') settotalRows(0);
				setHasMore(false);
			}
		} catch (error) {
			console.error('Error fetching services:', error);
		} finally {
			if (page <= 1) {
				setIsListLoading(false);
				// Mark that the first page has fully finished loading
				hasLoadedFirstPageRef.current = true;
			}
		}
	};

	const fetchSlider = async (branchId) => {
		const item = { action: 'slider_list', branch_id: branchId };
		try {
			const flechdata = await apiServicewt(item, navigate);
			if (Array.isArray(flechdata.data)) {
				if (flechdata.data.length > 0) {
					setVslider(flechdata.data);
				} else {
					setVslider(null);
				}
			}
		} catch (error) {
			setVslider(null);
		}
	};

	const fetchProductsWL = async (
		branchId,
		page = 1,
		limit = perPage,
		searchVal = '',
		signal = undefined,
	) => {
		const item = {
			action: 'get_product_list_wl',
			branch_id: branchId,
			page_id: page,
			limit: limit,
			search_value: searchVal,
		};
		try {
			if (page <= 1) {
				// Reset first-page loaded flag at the start of initial load
				hasLoadedFirstPageRef.current = false;
				setIsListLoading(true);
			}
			const flechdata = await apiServicewt(item, navigate, { signal });
			if (flechdata.data) {
				if (page > 1) {
					setProducts((prev) => [...prev, ...flechdata.data]);
				} else {
					setProducts(flechdata.data);
				}
			}
			let total = 0;
			if (flechdata.TotalRecords || flechdata.TotalRecords === 0) {
				total = flechdata.TotalRecords;
				setTotalRowsProducts(flechdata.TotalRecords);
				if (activeTab === 'products') settotalRows(flechdata.TotalRecords);
				const currentCount =
					(page - 1) * limit + (flechdata.data ? flechdata.data.length : 0);

				if (flechdata.data && flechdata.data.length > 0) {
					setHasMore(
						currentCount < Number(flechdata.TotalRecords) &&
							flechdata.data.length === limit,
					);
				} else {
					setHasMore(false);
				}
			} else {
				setTotalRowsProducts(0);
				if (activeTab === 'products') settotalRows(0);
				setHasMore(false);
			}
			return total;
		} catch (error) {
			console.error('Error fetching products:', error);
		} finally {
			if (page <= 1) {
				setIsListLoading(false);
				// Mark that the first page has fully finished loading
				hasLoadedFirstPageRef.current = true;
			}
		}
	};

	function handleRemove(id) {
		const newData = data.filter((item) => item.id !== id);
		setData(newData);
	}

	function handleEdit(id) {
		const newData = data.filter((item) => item.id === id);
		setEditItem(newData[0]);
	}

	const handlefunction = (pagenumber, limit, searchVal) => {
		const pagelimit = limit || perPage;
		if (!hasMore && pagenumber > 1) return;

		let branchIdToUse = branch?.data;
		if (!branchIdToUse) {
			branchIdToUse =
				localStorage.getItem('selectedBranch') ||
				(branches && branches[0] && branches[0].value);
		}
		if (!branchIdToUse) {
			setHasMore(false);
			return;
		}

		if (controllerRef.current) controllerRef.current.abort();
		controllerRef.current = new AbortController();
		const signal = controllerRef.current.signal;
		if (activeTab === 'services') {
			setIsLoadingMore(true);
			return fetchServices(
				branchIdToUse,
				pagenumber,
				pagelimit,
				searchVal !== undefined ? searchVal : searchValue,
				signal,
			).finally(() => setIsLoadingMore(false));
		} else {
			setIsLoadingMore(true);
			return fetchProductsWL(
				branchIdToUse,
				pagenumber,
				pagelimit,
				searchVal !== undefined ? searchVal : searchValue,
				signal,
			).finally(() => setIsLoadingMore(false));
		}
	};

	const cancelSmoothScroll = () => {
		try {
			if (scrollAnimRef.current.rafId) {
				cancelAnimationFrame(scrollAnimRef.current.rafId);
				scrollAnimRef.current.rafId = null;
			}

			if (scrollAnimRef.current.cancelHandler) {
				window.removeEventListener('wheel', scrollAnimRef.current.cancelHandler);
				window.removeEventListener('touchstart', scrollAnimRef.current.cancelHandler);
				window.removeEventListener('keydown', scrollAnimRef.current.cancelHandler);
				scrollAnimRef.current.cancelHandler = null;
			}
		} catch (e) {}
	};

	const smoothScrollToTop = (duration = 600) => {
		cancelSmoothScroll();
		const startY = window.scrollY || window.pageYOffset || 0;
		if (startY === 0) return;
		const startTime = performance.now();

		const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

		const animate = (now) => {
			const elapsed = now - startTime;
			const t = Math.min(1, elapsed / duration);
			const eased = easeOutCubic(t);
			const currentY = Math.round(startY * (1 - eased));
			window.scrollTo(0, currentY);
			if (t < 1) {
				scrollAnimRef.current.rafId = requestAnimationFrame(animate);
			} else {
				scrollAnimRef.current.rafId = null;
			}
		};

		const cancelHandler = () => cancelSmoothScroll();
		scrollAnimRef.current.cancelHandler = cancelHandler;
		window.addEventListener('wheel', cancelHandler, { passive: true });
		window.addEventListener('touchstart', cancelHandler, { passive: true });
		window.addEventListener('keydown', cancelHandler, { passive: true });

		scrollAnimRef.current.rafId = requestAnimationFrame(animate);
	};

	useEffect(() => {
		return () => {
			cancelSmoothScroll();
		};
	}, []);

	const formik = useFormik({
		initialValues: {
			name: '',
			price: '',
			stock: '',
			category: '',
		},
		onSubmit: (values) => {
			setEditPanel(false);
		},
	});

	useEffect(() => {
		if (editItem) {
			formik.setValues({
				name: editItem.name,
				price: editItem.price,
				stock: editItem.stock,
				category: editItem.category,
			});
		}
		return () => {
			formik.setValues({
				name: '',
				price: '',
				stock: '',
				category: '',
			});
		};
	}, [editItem]);

	const images = [
		{ id: 'Pic', img: Pic },
		{ id: 'Pic2', img: Pic2 },
		{ id: 'Pic3', img: Pic3 },
		{ id: 'Pic4', img: Pic4 },
		{ id: 'Pic5', img: Pic5 },
		{ id: 'Pic6', img: Pic6 },
		{ id: 'Pic7', img: Pic7 },
		{ id: 'Pic8', img: Pic8 },
	];

	const _gallery = (
		<div className='row g-4'>
			{images.map((item, index) => (
				<div key={item.id} className='col-xxl-2 col-lg-3 col-md-6'>
					<button
						type='button'
						onClick={() => setSelectedImage(item.img)}
						className={classNames(
							'ratio ratio-1x1',
							'rounded-2',
							'border-0',
							`bg-l${darkModeStatus ? 'o25' : '25'}-${colors[index % 7]}`,
							`bg-l${darkModeStatus ? 'o50' : '10'}-${colors[index % 7]}-hover`,
						)}>
						<img
							src={item.img}
							alt={item.id}
							width='100%'
							height='auto'
							className='object-fit-contain p-4'
						/>
					</button>
				</div>
			))}
		</div>
	);

	const SecondLayout = ({ d, i }) => {
		let url = d.url || '';
		try {
			const siteDomain = window.location.origin;
			if (url.startsWith(siteDomain)) {
				url = url.slice(siteDomain.length);
				if (url.startsWith('/')) url = url.slice(1);
			}

			if (!/^https?:\/\//i.test(url)) {
				url = 'https://' + url;
			}
		} catch (e) {}
		return (
			<CarouselSlide key={i}>
				<a href={url} target='_blank' rel='noopener noreferrer'>
					<div key={i} className='carousel-slide-bg csl-slide'>
						<img src={d.slider_img} />
					</div>
				</a>
			</CarouselSlide>
		);
	};

	const defaultUrl = 'www.schedulerdesk.com';
	const rawUrl = sitename.website_url || '';
	let displayUrl = rawUrl || defaultUrl;
	let linkURL = displayUrl;
	if (linkURL && !linkURL.match(/^(http|https|ftp):\/\//i)) {
		linkURL = `https://${linkURL}`;
	}

	const showNoServices = !isListLoading && totalRowsServices === 0;
	const showNoProducts = !isListLoading && totalRowsProducts === 0;

	return (
		<PageWrapper>
			<Page container='fluid'>
				<SubHeader
					style={{
						alignContent: 'center',
						// On mobile, allow content to stack nicely
						padding: isMobile ? '8px 8px 0 8px' : undefined,
					}}>
					<SubHeaderLeft
						className='subheader-left'
						style={{
							marginBottom: isMobile ? 8 : 0,
							width: isMobile ? '100%' : 'auto',
						}}>
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: isMobile ? 'space-between' : 'flex-start',
								gap: 8,
								width: '100%',
							}}>
							<a
								href={linkURL}
								target='_blank'
								className={classNames('text-decoration-none', {
									'link-dark': !darkModeStatus,
									'link-light': darkModeStatus,
								})}
								style={{
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}>
								{/* <span>{sitename.website_url || 'schedulerdesk.com'}</span> */}
								<Logo width={200} />
							</a>
							{isMobile && <ThemeLangControls />}
						</div>
					</SubHeaderLeft>
					<div
						className={
							logbtn == 'ab' ? '' : 'subheader-right col-sm-auto subheader-right'
						}
						style={{
							display: 'flex',
							alignItems: 'center',
							width: isMobile ? '100%' : undefined,
							justifyContent: isMobile ? 'space-between' : undefined,
						}}>
						<div
							style={{
								display: 'flex',
								flexDirection: logbtn == 'ab' ? 'column' : 'row',
								alignItems: 'center',
								width: isMobile ? '100%' : undefined,
							}}>
							{branches && branches.length > 1 && (
								<div
									className='branch-select-wrapper'
									style={{
										fontSize: '12px',
										paddingTop: '6px',
										paddingBottom: '6px',
										marginRight: isMobile ? 0 : '16px',
										width: isMobile ? '100%' : '200px',
									}}>
									<FormGroup
										id='branch'
										className='col-12'
										style={{ marginBottom: 0 }}>
										<div style={{ display: 'flex', alignItems: 'center' }}>
											<Select
												placeholder={`${t('Choose')}...`}
												list={branches}
												value={branch.data}
												style={{
													border: branch.error
														? '2px solid red'
														: '1px solid transparent',
													lineHeight: '20px',
													fontSize: '13px',
													width: isMobile
														? '100%'
														: 'webkit-fill-available',
													borderRadius: '6px',
													height: 36,
													padding: '4px 8px',
												}}
												onChange={handleBranchChange}
											/>
										</div>
									</FormGroup>
								</div>
							)}
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: 8,
									width: isMobile ? '100%' : 'auto',
								}}>
								{!isMobile && (
									<div className='row g-3'>
										<div className='col-auto'>
											<ThemeLangControls />
										</div>
									</div>
								)}
								<div style={{ display: 'flex', width: isMobile ? '100%' : 'auto' }}>
									<Button
										style={{
											margin: '10px',
											flex: logbtn == 'ab' ? 1 : undefined,
										}}
										className='hdr-btn'
										color='success'
										isLight
										icon='Login'
										onClick={() => {
											navigate('/login?type=login');
										}}>
										{t('Log In')}
									</Button>

									<Button
										style={{
											borderRadius: '10px',
											margin: '10px',
											flex: logbtn == 'ab' ? 1 : undefined,
										}}
										color='info'
										isLight
										icon='PersonAddAlt'
										onClick={() => {
											navigate('/login?type=reg');
										}}>
										{t('Sign Up')}
									</Button>
								</div>
							</div>
						</div>
					</div>
				</SubHeader>
				{vslider && (
					<div className='col-12 vslider-dev' style={{ marginTop: 24 }}>
						<Carousel
							isHoverPause
							isRide
							rounded={0}
							height={height || '100%'}
							isDark={darkModeStatus}>
							{vslider?.map((d, i) => {
								return <SecondLayout d={d} i={i} key={i} />;
							})}
						</Carousel>
					</div>
				)}
				<div
					style={{
						width: '100%',
						marginTop: '24px',
						marginBottom: '12px',
						display: 'flex',
						justifyContent: isMobile ? 'center' : 'flex-start',
					}}>
					<div
						style={{
							display: 'inline-flex',
							alignItems: 'center',
							gap: 8,
							marginLeft: isMobile ? 0 : '12px',
							background: darkModeStatus ? '#242731' : '#ffffff',
							padding: '6px',
							borderRadius: '999px',
							boxShadow: darkModeStatus
								? '0 6px 18px rgba(0,0,0,0.6)'
								: '0 6px 18px rgba(16,24,40,0.08)',
							maxWidth: isMobile ? '100%' : 'auto',
							overflowX: isMobile ? 'auto' : 'visible',
							flexWrap: isMobile ? 'wrap' : 'nowrap',
						}}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
							{(() => {
								const tabButtonStyle = {
									// Flexible width tabs that wrap on small screens
									flex: isMobile ? '1 1 140px' : '0 0 140px',
									minWidth: isMobile ? 120 : 140,
									padding: '10px 8px',
									borderRadius: '999px',
									cursor: 'pointer',
									textAlign: 'center',
									fontWeight: 600,
									margin: '2px',
								};
								return (
									<div
										style={{
											...tabButtonStyle,
											color:
												activeTab === 'services'
													? '#ffffff'
													: darkModeStatus
													? '#e5e5e5'
													: '#222222',
											background:
												activeTab === 'services'
													? '#6c5dd3'
													: 'transparent',
											boxShadow:
												activeTab === 'services'
													? darkModeStatus
														? '0 2px 6px rgba(0,0,0,0.5)'
														: '0 2px 6px rgba(108,93,211,0.25)'
													: 'none',
											border:
												activeTab === 'services'
													? 'none'
													: `1px solid ${
															darkModeStatus
																? 'rgba(255,255,255,0.06)'
																: 'rgba(0,0,0,0.06)'
													  }`,
										}}
										onClick={() => {
											if (controllerRef.current)
												controllerRef.current.abort();
											setActiveTab('services');
											setCurrentPage(1);
											setHasMore(true);
											setData([]);
											settotalRows(
												totalRowsServices !== null
													? totalRowsServices
													: null,
											);
											fetchServices(branch.data);
										}}>
										{t('Services')}
										{activeTab === 'services' && (
											<span
												style={{
													marginLeft: 8,
													opacity: 1,
													background: '#ffffff',
													color: '#111',
													padding: '2px 8px',
													borderRadius: 999,
													fontSize: 12,
													boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
												}}>
												{`${
													totalRowsServices !== null
														? totalRowsServices
														: '...'
												}`}
											</span>
										)}
									</div>
								);
							})()}
							{(() => {
								const tabButtonStyle = {
									flex: isMobile ? '1 1 140px' : '0 0 140px',
									minWidth: isMobile ? 120 : 140,
									padding: '10px 8px',
									borderRadius: '999px',
									cursor: 'pointer',
									textAlign: 'center',
									fontWeight: 600,
									margin: '2px',
								};
								return (
									<div
										style={{
											...tabButtonStyle,
											color:
												activeTab === 'products'
													? '#ffffff'
													: darkModeStatus
													? '#e5e5e5'
													: '#222222',
											background:
												activeTab === 'products'
													? '#6c5dd3'
													: 'transparent',
											boxShadow:
												activeTab === 'products'
													? darkModeStatus
														? '0 2px 6px rgba(0,0,0,0.5)'
														: '0 2px 6px rgba(108,93,211,0.25)'
													: 'none',
											border:
												activeTab === 'products'
													? 'none'
													: `1px solid ${
															darkModeStatus
																? 'rgba(255,255,255,0.06)'
																: 'rgba(0,0,0,0.06)'
													  }`,
										}}
										onClick={() => {
											if (controllerRef.current)
												controllerRef.current.abort();
											setActiveTab('products');
											setCurrentPage(1);
											setHasMore(true);
											setProducts([]);
											settotalRows(
												totalRowsProducts !== null
													? totalRowsProducts
													: null,
											);
											fetchProductsWL(branch.data);
										}}>
										{t('Products')}
										{activeTab === 'products' && (
											<span
												style={{
													marginLeft: 8,
													opacity: 1,
													background: '#ffffff',
													color: '#111',
													padding: '2px 8px',
													borderRadius: 999,
													fontSize: 12,
													boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
												}}>
												{`${
													totalRowsProducts !== null
														? totalRowsProducts
														: '...'
												}`}
											</span>
										)}
									</div>
								);
							})()}
						</div>
					</div>
					{/* <div
						style={{
							marginLeft: 'auto',
							display: 'flex',
							alignItems: 'center',
							marginRight: '12px',
						}}>
						<span className='text-muted' style={{ marginRight: 8 }}>
							{t('Show')}
						</span>
						<Select
							size='sm'
							ariaLabel='Per'
							onChange={(e) => {
								const newPerPage = parseInt(e.target.value, 10);
								setPerPage(newPerPage);
								setCurrentPage(1);
								handlefunction(1, newPerPage);
							}}
							value={perPage.toString()}>
							{Object.keys(PER_COUNT).map((i) => (
								<SelectOption key={i} value={i}>
									{i}
								</SelectOption>
							))}
						</Select>
					</div> */}
				</div>
				<div className='inner-wrapper'>
					<AnimatePresence mode='wait'>
						<motion.div
							key={activeTab}
							initial={{ opacity: 0, y: 8 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0, y: -8 }}
							transition={{ duration: 0.22, ease: 'easeInOut' }}
							style={{ width: '100%', height: '-webkit-fill-available' }}>
							{activeTab === 'services' &&
								(isListLoading ? (
									<div
										className='d-flex justify-content-center align-items-center'
										style={{ minHeight: '40vh', width: '100%' }}>
										<div
											className='spinner-border'
											role='status'
											aria-live='polite'
											aria-busy='true'>
											<span className='visually-hidden'>Loading...</span>
										</div>
									</div>
								) : data && data.length > 0 ? (
									data.map((item) => (
										<div
											id={`home-item-${item.id}`}
											className='sub_inner_wrapper'
											key={item.id}
											onClick={() => {
												saveHomeCache(item.id);
												navigate(
													`/${layoutMenu.view_servwl.path}/${item.id}`,
												);
											}}>
											<CommonGridProductItem
												id={item.id}
												name={item.name}
												category={item.catname}
												currency={scurrency}
												img={JSON.parse(item.filepath)[0]}
												color='#46bcaa'
												price={item.price}
												pts={
													item.price_in_points !== null &&
													item.price_in_points !== 0 &&
													item.is_enable_points
														? item.price_in_points
														: null
												}
												editAction={() => {
													setEditPanel(true);
													handleEdit(item.id);
												}}
												deleteAction={() => handleRemove(item.id)}
												service_lable={item.service_lable || ''}
											/>
										</div>
									))
								) : showNoServices ? (
									<NoItems message={t('No services found')} />
								) : null)}

							{activeTab === 'products' &&
								(isListLoading ? (
									<div
										className='d-flex justify-content-center align-items-center'
										style={{ minHeight: '40vh', width: '100%' }}>
										<div
											className='spinner-border'
											role='status'
											aria-live='polite'
											aria-busy='true'>
											<span className='visually-hidden'>Loading...</span>
										</div>
									</div>
								) : products && products.length > 0 ? (
									products.map((item) => (
										<div
											id={`home-item-${item.id}`}
											className='sub_inner_wrapper'
											key={item.id}
											onClick={() => {
												saveHomeCache(item.id);
												navigate(
													`/${layoutMenu.view_productvwl.path}/${item.id}`,
												);
											}}>
											<CommonProductView
												id={item?.id}
												name={item?.name}
												quantity={item?.is_out_of_stock}
												currency={scurrency}
												img={item?.filepath[0] || ' '}
												color='#46bcaa'
												price={item?.price}
												linkPath={layoutMenu.view_productvwl.path}
												editAction={() => {
													setEditPanel(true);
													handleEdit(item?.id);
												}}
												deleteAction={() => handleRemove(item?.id)}
											/>
										</div>
									))
								) : showNoProducts ? (
									<NoItems message={t('No products found')} />
								) : null)}
						</motion.div>
					</AnimatePresence>
				</div>
				<div style={{ textAlign: 'center', padding: 12 }}>
					{!isListLoading &&
						isLoadingMore &&
						hasMore &&
						((activeTab === 'services' && data.length > 0) ||
							(activeTab === 'products' && products.length > 0)) && (
							<div className='spinner-border' role='status'>
								<span className='visually-hidden'>Loading...</span>
							</div>
						)}
					<div ref={bottomRef} style={{ height: 1 }} />
				</div>

				<AnimatePresence>
					{showScrollTop && (
						<motion.div
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0, y: 20 }}
							transition={{ duration: 0.28 }}>
							<Popovers trigger='hover' desc={t('Back to top')}>
								<motion.button
									aria-label='Scroll to top'
									onClick={() => smoothScrollToTop(600)}
									whileHover={{ scale: 1.06 }}
									whileTap={{ scale: 0.96 }}
									style={{
										position: 'fixed',
										bottom: 52,
										right: 10,
										width: 52,
										height: 52,
										borderRadius: 999,
										background:
											'linear-gradient(135deg,#6c5dd3 0%,#9b74ff 100%)',
										color: '#fff',
										border: 'none',
										boxShadow: '0 10px 30px rgba(108,93,211,0.3)',
										cursor: 'pointer',
										zIndex: 9999,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}>
									<Icon icon='ArrowUpward' size='2x' />
								</motion.button>
							</Popovers>
						</motion.div>
					)}
				</AnimatePresence>
			</Page>
		</PageWrapper>
	);
};

export default Home;
